module.exports = "/_next/static/images/home-monotone-bbcf7a9b10d6ff874151804e229830ad.svg";